import { useEffect, useState } from 'react'

import { LocalStorageKeys, MainThemeVariants, ThemeVariants } from 'src/types'

import { getActiveTheme } from 'src/helpers/getActiveTheme'

export const useTheme = () => {
  const initialTheme =
    (localStorage.getItem(LocalStorageKeys.THEME) as ThemeVariants) ||
    ThemeVariants.DARK

  const initialColorTheme =
    (localStorage.getItem(LocalStorageKeys.COLOR_THEME) as MainThemeVariants) ||
    MainThemeVariants.DEFAULT

  const [theme, setTheme] = useState<ThemeVariants>(() =>
    getActiveTheme(initialTheme),
  )

  const [colorTheme, setColorTheme] =
    useState<MainThemeVariants>(initialColorTheme)

  const handleSetTheme = (themeValue: ThemeVariants) => {
    const newThemeValue = getActiveTheme(themeValue)

    setTheme(newThemeValue)
    localStorage.setItem(LocalStorageKeys.THEME, newThemeValue)

    if (newThemeValue === ThemeVariants.DARK) {
      document.documentElement.classList.add(ThemeVariants.DARK)
      document.documentElement.classList.remove(ThemeVariants.LIGHT)

      return
    }

    document.documentElement.classList.add(ThemeVariants.LIGHT)
    document.documentElement.classList.remove(ThemeVariants.DARK)
  }

  const handleSetColorTheme = (themeValue: MainThemeVariants): void => {
    localStorage.setItem(LocalStorageKeys.COLOR_THEME, themeValue)
    document.documentElement.setAttribute('data-theme', themeValue)
    setColorTheme(themeValue)
  }

  useEffect(() => {
    handleSetTheme(getActiveTheme(theme))
    handleSetColorTheme(initialColorTheme)
  }, [])

  return {
    theme,
    handleSetTheme,
    colorTheme,
    handleSetColorTheme,
    isDark: theme === ThemeVariants.DARK,
  }
}
